import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhotoLibrary = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 20,
	viewBox: "0 -960 960 960",
	width: 20,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M360-384h384L618-552l-90 120-66-88-102 136Zm-48 144q-29.7 0-50.85-21.15Q240-282.3 240-312v-480q0-29.7 21.15-50.85Q282.3-864 312-864h480q29.7 0 50.85 21.15Q864-821.7 864-792v480q0 29.7-21.15 50.85Q821.7-240 792-240H312Zm0-72h480v-480H312v480ZM168-96q-29.7 0-50.85-21.15Q96-138.3 96-168v-552h72v552h552v72H168Zm144-696v480-480Z" })
});
export default SvgPhotoLibrary;
